import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './util/rem'
import './plugins/iview'
import BaiduMap from 'vue-baidu-map'
import VDistpicker from 'v-distpicker'
// import './assets/js/gambit'
// import './assets/js/gambit.all'
// import chessRule from './util/ChessRule'

// Vue.prototype.chessRule = chessRule

Vue.component('v-distpicker', VDistpicker)
Vue.use(VueAxios, axios)
Vue.use(BaiduMap, {
  ak: '6RlZGXkNWBzgZCfEg2AERnBfysAMpUEi'
})
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js